import React from "react";
import { Box, Typography } from "@mui/material";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import { motion } from "framer-motion";
import LogoHeader from "../components/LogoHeader";

export default function QuickMomentPage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#FFFFFF",
        px: 2,
        pt: 1.5,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* 🔝 LifeShot Header (same as HomeFeed) */}
      <LogoHeader />

      {/* 🌩️ Empty State */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          pb: 6,
        }}
      >
        {/* Thunder Icon */}
        <motion.div
          initial={{ scale: 0.85, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          style={{
            width: 120,
            height: 120,
            borderRadius: "50%",
            background: "linear-gradient(145deg, #E7FEEB, #D1FADF)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 24,
          }}
        >
          <FlashOnIcon sx={{ fontSize: 60, color: "#16A34A" }} />
        </motion.div>

        {/* Title */}
        <Typography
          sx={{
            fontSize: "1.3rem",
            fontWeight: 700,
            color: "#111827",
            mb: 1,
          }}
        >
          No active moment
        </Typography>

        {/* Subtitle */}
        <Typography
          sx={{
            fontSize: "0.95rem",
            color: "#6B7280",
            maxWidth: 280,
            lineHeight: 1.6,
          }}
        >
          When someone invites you — or you open a moment — it will appear here.
        </Typography>
      </Box>
    </Box>
  );
}
